import React from "react";
import { Loader2 } from "lucide-react";
import { Typography } from "./Typography";
import { cn } from "@/lib/utils/cn";

export interface SpinnerProps {
  size?: "sm" | "md" | "lg" | "xl";
  variant?: "primary" | "secondary" | "white";
  className?: string;
}

const sizeStyles = {
  sm: "w-4 h-4",
  md: "w-6 h-6",
  lg: "w-8 h-8",
  xl: "w-12 h-12",
};

const variantStyles = {
  primary: "text-navigator-primary",
  secondary: "text-gray-600",
  white: "text-white",
};

export function Spinner({
  size = "md",
  variant = "primary",
  className = "",
}: SpinnerProps) {
  const sizeClass = sizeStyles[size];
  const variantClass = variantStyles[variant];

  return (
    <Loader2
      className={cn("animate-spin", sizeClass, variantClass, className)}
    />
  );
}

// Full page loading overlay
export function SpinnerOverlay({ message }: { message?: string }) {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white/80 backdrop-blur-sm">
      <Spinner size="xl" />
      {message && (
        <Typography variant="body" weight="medium" color="muted" className="mt-4">{message}</Typography>
      )}
    </div>
  );
}
